
$(function () {
    $('[maxlength]').each(function () {

        const $self = $(this);

        updateCharactersRemaining($self);

        $self.on('keyup', function () {
            updateCharactersRemaining($self);
        });
    });

    $('#buttonChangeTimezone').on('click', function () {
        $('#timezoneMessage').hide();
        $('#timezoneSelector').show();
    });

    $('input[name="deliverywhen"]').on('change', function () {

        if ($('input[name="deliverywhen"]:checked').val() === 'specific') {
            $('#containerSpecificDeliveryDate').slideDown();
        } else {
            $('#containerSpecificDeliveryDate').slideUp();
        }
    });

    $('#checkboxNextDayDelivery').on('change', function () {

        const $self = $(this);
        const $hiddenSetter = $('#hiddenDeliveryTypeSetter');

        if ($self.is(':checked')) {
            $hiddenSetter.val('nextday');
            $('#datepickerDeliveryDate').datetimepicker('disable');
        } else {
            $hiddenSetter.val('standard');
            $('#datepickerDeliveryDate').datetimepicker('enable');
        }
    });

    $('[name="DeliveryDate"], [name="DeliveryHour"], [name="DeliveryMinute"]').on('change blur', function () {
        if ($('body').hasClass('byemail')) {
            validateDeliveryDateForByEmail();
        }
    });
});

function updateCharactersRemaining($input) {

    const maxLength = $input.attr('maxlength');

    const current = $input.val().length;
    const remaining = maxLength - current;

    const $message = $input.siblings('.characters-remaining').first();

    if ($message !== undefined && $message !== null) {

        $message.find('.count').text(remaining);

        if (remaining < 0) {
            $message.addClass('exceeded');
        } else {
            $message.removeClass('exceeded');
        }
    }
}

window.validateDeliveryDateForByEmail = function () {

    var isValid = true;

    const specificDelivery = $('[name="deliverywhen"]:checked').val() === 'specific';

    if (specificDelivery) {


        if (deliveryDateIsUndefined()) {

            isValid = false;
            $('#deliveryDateValidation_Required').show();

        } else {

            $('#deliveryDateValidation_Required').hide();
        }

        if (deliveryDateIsInThePast()) {

            isValid = false;
            $('#deliveryDateValidation_IsPast').show();

        } else {

            $('#deliveryDateValidation_IsPast').hide();
        }
    }

    toggleDeliveryDateValidationClasses(isValid);

    return isValid;
}

function deliveryDateIsInThePast() {
    const deliveryDate = $('[name="DeliveryDate"]').val();
    const deliveryTimeHour = $('[name="DeliveryHour"]').val();
    const deliveryTimeMinute = $('[name="DeliveryMinute"]').val();

    const selected = Date.parse(deliveryDate + ' ' + deliveryTimeHour + ':' + deliveryTimeMinute + ':00');
    const current = Date.parse(new Date());

    if (selected < current) {
        return true;
    } else {
        return false;
    }
}

function deliveryDateIsUndefined() {
    const deliveryDate = $('[name="DeliveryDate"]').val();

    if (deliveryDate === undefined || deliveryDate === null || deliveryDate === '') {
        return true;
    } else {
        return false;
    }
}

function toggleDeliveryDateValidationClasses(isValid) {

    const selector =
        '[name="DeliveryDate"] + input-group,' +
        '[name="DeliveryDate"] + input-group input[type="text"],' +
        '[name="DeliveryHour"],' +
        '[name="DeliveryMinute"]'
        ;

    if (isValid) {
        $(selector).removeClass('is-invalid').addClass('is-valid');

    } else {
        $(selector).removeClass('is-valid').addClass('is-invalid');
    }
}
